/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, qty: NonNullable<unknown> }} Stocktake_Snapshot_Batch_QtyInputs */

const vi_stocktake_snapshot_batch_qty = /** @type {(inputs: Stocktake_Snapshot_Batch_QtyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} lô • ${i?.qty} đơn vị`)
};

/**

* @param {Stocktake_Snapshot_Batch_QtyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_snapshot_batch_qty = /** @type {((inputs: Stocktake_Snapshot_Batch_QtyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Snapshot_Batch_QtyInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_snapshot_batch_qty(inputs)
});